import { faTrash, faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import cn from 'classnames';
import Text from '../../../components/common/custom-text/custom-text.jsx';
import styles from './workspace-list-item.module.scss';

function WorkspaceListItem({ workspace, onDelete, isDeleting }) {
  const { name, iconUrl } = workspace;
  const defaultIconUrl = '/res/brand_icon.svg';

  return (
    <div className={styles.workspaceCard}>
      <img src={iconUrl || defaultIconUrl} alt="Workspace Icon" className={styles.workspaceIcon} />
      <Text variant="l3" color="#324975" className={styles.workspaceName}>
        {name}
      </Text>
      <button
        className={cn(styles.deleteWorkspaceButton, {
          [styles.alwaysVisible]: isDeleting,
        })}
        onClick={onDelete}
        disabled={isDeleting}
        aria-label={`Delete workspace ${name}`}
        data-testid="delete-workspace-button"
      >
        {isDeleting
          ? <FontAwesomeIcon icon={faCircleNotch} spin />
          : <FontAwesomeIcon icon={faTrash} />}
      </button>
    </div>
  );
}

export default WorkspaceListItem;
